'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import {FaUserAlt, FaInfoCircle} from "react-icons/fa";

import Alert from 'react-bootstrap/Alert';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import BannerMessages from '@uw-it-sis/lib-react/lib/BannerMessages';

import RegistrationTermButton from "./RegistrationTermButton";
import AppNavigationToggle from "./AppNavigationToggle";

/**
 * Button and content for the profile widget.
 *
 * Handling the open/close of the DropdownButton to prevent the componentDidMount method to be called
 * whether it's contents are being displayed or not.
 */
class ProfileButton extends Component {

    constructor(props) {
        super(props);

        // Bind this to click handlers.
        this.logout = this.logout.bind(this);
        this.login = this.login.bind(this);
    }

    login = () => appStore.doLogin();

    logout = async () => {
        appStore.logout();
    };

    render() {
        if (appStore.isAuthenticated()) {
            if (appStore.isAdviser()) {
                return (
                    <Nav.Link id="sign-out" onClick={this.logout}>
                        <FaUserAlt className="me-2 d-none d-sm-inline" />
                        Sign Out
                    </Nav.Link>
                );
            } else {
                return (
                    <>
                        <Nav.Link id="user-account" href="/home/#/account">
                            <FaUserAlt className="me-2" />
                            <span className="d-none d-sm-inline">
                                {appStore.getUserName()}
                            </span>
                        </Nav.Link>
                        <Nav.Link id="sign-out" onClick={this.logout}>
                            Sign Out
                        </Nav.Link>
                    </>
                );
            }
        } else {
            return (
                <Nav.Link id="sign-in-header" onClick={this.login}>
                    <FaUserAlt className="me-2 d-none d-sm-inline" />
                    Sign In
                </Nav.Link>
            );
        }
    }
}

/**
 * The Header component.
 */
const Header = ({showAppNavigation = true}) => {
    let navigation;
    let additionalComponent = null;
    /* Populate the navigation toggle component if show app nav is true */
    if ( showAppNavigation ) {
        navigation = <AppNavigationToggle />;
    }

    const getAdditionalComponent = () => {
        return (
            <Alert variant="warning" className="d-print-none px-3 py-2 mb-0 border-0 rounded-0 d-flex align-items-start">
                <FaInfoCircle className="me-2 fs-5" aria-hidden={true} />
                <div>
                    This is the adviser view of the plan for <strong>{appStore.getDisplayName()} ({appStore.getStudentNumber()})</strong>. You can add recommendations for this
                    student. <a href="https://itconnect.uw.edu/tools-services-support/academic-planning/myplan-academic-planner/adviser-help/" target="_blank" title="Learn more about the adviser view">Learn
                    more about what you can do in adviser view</a>.
                </div>
            </Alert>
        );
    };

    /* Populate the adviser banner message if user is in adviser mode */
    if ( appStore.isAdviser() ) {
        additionalComponent = getAdditionalComponent();
    }

    return (
        <header role="banner">
            <BannerMessages additionalComponent={additionalComponent}/>
            <Navbar bg="dark" variant="dark" className="navbar-custom justify-content-between d-print-none">
                <Nav aria-label="University of Washington">
                    <Nav.Link href='https://myuw.washington.edu' target="_blank">MyUW</Nav.Link>
                    <Nav.Link href='http://www.washington.edu/' target="_blank">UW.edu</Nav.Link>
                </Nav>
                <Nav aria-label="Account Options">
                    <ProfileButton />
                </Nav>
            </Navbar>
            <div className="d-flex justify-content-between bg-purple px-3 py-2">
                <div className="d-flex align-items-center">
                    {navigation}
                    <a href="/home" className="navbar-brand text-white fs-1">MyPlan</a>
                </div>
                <RegistrationTermButton />
            </div>
        </header>
    );
}

Header.propTypes = {
    /* Flag as to whether or not to show the nav toggle in the header, defaults to true */
    showAppNavigation : PropTypes.bool
};

export default Header;
